import dayjs from 'dayjs'
import * as XLSX from 'xlsx'

export default function readBudget (workbook, sheetTarget) {
  console.log('readBudget', workbook, sheetTarget)

  const targetSheetName = Number.isFinite(sheetTarget) ? workbook.SheetNames[sheetTarget] : sheetTarget
  const worksheet = workbook.Sheets[targetSheetName]
  console.log('worksheet', worksheet)
  console.log('worksheet E14', worksheet?.E14)
  console.log('worksheet C27', worksheet?.C27)
  console.log('worksheet E28', worksheet?.E28)

  const sheetHeaders = getSheetHeaders(worksheet)
  console.log('sheetHeaders', sheetHeaders)

  const sheetData = getSheetData(worksheet)
  console.log('sheetData', sheetData)

  const parsedData = parseBudget(sheetData, sheetHeaders)
  console.log('parsedData', parsedData)

  return {
    parsedData,
    sheetHeaders
  }
}

function getSheetData (worksheet) {
  const sheetData = XLSX.utils.sheet_to_json(worksheet)
  console.log('sheetData', sheetData)
  return sheetData
}

function getSheetHeaders (worksheet) {
  // header: 1 to return Array of Array instead of Array of Object
  const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
  console.log('sheetData', sheetData)
  const columnNames = sheetData[0]
  console.log('columnNames', columnNames)

  const columnsInfos = columnNames.map(function (columnName) {
    console.log('columnName', columnName)
    const potentialDate = dayjs(columnName)
    const asDate = potentialDate.isValid() ? potentialDate.format('YYYY-MM-01') : null
    return {
      name: columnName,
      index: columnNames.indexOf(columnName),
      asDate
    }
  })
  return columnsInfos
}

function parseBudget (sheetData, columnsInfos) {
  console.log('parseBudget', sheetData)
  const columns = columnsInfos
  console.log('columns', columns)

  const targetColumnName = '*Account'

  const parsedData = sheetData.map(function (row) {
    console.log('row', row)
    const parsedItem = parseItemAccount(row[targetColumnName])
    let totalAmount = 0
    columnsInfos.forEach(function (columnInfo) {
      if (!columnInfo.asDate) return
      totalAmount += Number.isFinite(row[columnInfo.name]) ? row[columnInfo.name] : 0
    })
    // Object.values(row).reduce((acc, curr) => acc + (Number.isFinite(curr) ? curr : 0), 0)

    console.log('parsedItem', parsedItem)
    return {
      rowData: row,
      ledgerAccountInfo: parsedItem,
      totalAmount
    }
  })
  console.log('parsedData', parsedData)
  return parsedData
}

function parseItemAccount (itemString) {
  if (!itemString || typeof itemString !== 'string') {
    return { name: '', code: '' }
  }

  // Pattern to match: name (code)
  // This regex captures the name before the parentheses and the code inside
  const match = itemString.match(/^(.+?)\s*\(([^)]+)\)$/)

  const name = match?.[1]?.trim() || itemString.trim()
  const code = match?.[2]?.trim() || ''

  return {
    name,
    code
  }
}
